export default class ResetPassword {
  constructor() {
    this.token = ''
    this.email = ''
    this.password = ''
    this.password_confirmation = ''
  }
}
